import { render } from "./MobileTabBar.vue?vue&type=template&id=1710ac00&scoped=true"
import script from "./MobileTabBar.vue?vue&type=script&lang=js"
export * from "./MobileTabBar.vue?vue&type=script&lang=js"

import "./MobileTabBar.vue?vue&type=style&index=0&id=1710ac00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1710ac00"]])

export default __exports__